import type { GameEvent } from "@/types"

export const ursusEvents: Record<string, GameEvent> = {
    "dlg-us-poca": {
        id: "dlg-us-poca",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.doctor",
                expression: "confused",
                side: "left",
                text: "map.dialog.usPoca.d1",
            },
            {
                speaker: "map.speaker.poca",
                expression: "normal",
                side: "right",
                text: "map.dialog.usPoca.d2",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "left",
                text: "map.dialog.usPoca.d3",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "thinking",
                side: "left",
                text: "map.dialog.usPoca.d4",
            },
            {
                speaker: "map.speaker.poca",
                expression: "normal",
                side: "right",
                text: "map.dialog.usPoca.d5",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "left",
                text: "map.dialog.usPoca.d6",
            },
            {
                speaker: "map.speaker.poca",
                expression: "normal",
                side: "right",
                text: "map.dialog.usPoca.d7",
            },
            {
                speaker: "map.speaker.poca",
                expression: "happy",
                side: "right",
                text: "map.dialog.usPoca.d8",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "left",
                text: "map.dialog.usPoca.d9",
            },
            {
                speaker: "map.speaker.poca",
                expression: "happy",
                side: "right",
                text: "map.dialog.usPoca.d10",
            },
        ],
        choices: [],
    },

    "dlg-us-udon": {
        id: "dlg-us-udon",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.udon",
                expression: "normal",
                side: "left",
                text: "map.dialog.usUdon.d1",
            },
            {
                speaker: "map.speaker.savage",
                expression: "happy",
                side: "right",
                text: "map.dialog.usUdon.d2",
            },
            {
                speaker: "map.speaker.udon",
                expression: "normal",
                side: "left",
                text: "map.dialog.usUdon.d3",
            },
            {
                speaker: "map.speaker.udon",
                expression: "normal",
                side: "left",
                text: "map.dialog.usUdon.d4",
            },
            {
                speaker: "map.speaker.udon",
                expression: "normal",
                side: "left",
                text: "map.dialog.usUdon.d5",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.usUdon.d6",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "thinking",
                side: "right",
                text: "map.dialog.usUdon.d7",
            },
            {
                speaker: "map.speaker.udon",
                expression: "unhappy",
                side: "left",
                text: "map.dialog.usUdon.d8",
            },
        ],
        choices: [],
    },

    "evt-us-01": {
        id: "evt-us-01",
        type: "event",
        description: "map.event.us01.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.us01.c1",
                resultText: "map.event.us01.c1r",
                nextDialogues: [],
            },
            {
                id: "c2",
                text: "map.event.us01.c2",
                resultText: "map.event.us01.c2r",
                nextDialogues: [],
            },
        ],
    },

    "evt-us-02": {
        id: "evt-us-02",
        type: "event",
        description: "map.event.us02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.us02.c1",
                resultText: "map.event.us02.c1r",
                nextDialogues: [],
            },
            {
                id: "c2",
                text: "map.event.us02.c2",
                resultText: "map.event.us02.c2r",
                nextDialogues: [],
            },
        ],
    },

    "evt-us-03": {
        id: "evt-us-03",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-ursus-3.png"),
        description: "map.event.us03.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.us03.c1",
                resultText: "map.event.us03.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "normal",
                        text: "map.event.us03.c1d",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.us03.c2",
                resultText: "map.event.us03.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.us03.c2d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-us-01",
    },

    "evt-us-04": {
        id: "evt-us-04",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-ursus-4.png"),
        description: "map.event.us04.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.us04.c1",
                resultText: "map.event.us04.c1r",
                nextDialogues: [],
            },
        ],
        unlockGalleryId: "gal-us-02",
    },

    "evt-us-05": {
        id: "evt-us-05",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-ursus-5.png"),
        description: "map.event.us05.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.us05.c1",
                resultText: "map.event.us05.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.poca",
                        expression: "happy",
                        text: "map.event.us05.c1d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-us-03",
    },
}
